import './assets/styles/common.scss';

import * as Sentry from '@sentry/react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';

import App from './App';
import { enableMocking } from './mocks';
import { store } from './redux/store';

import.meta.env.PROD &&
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_URL,
    sendDefaultPii: true,
    integrations: [Sentry.replayIntegration(), Sentry.browserTracingIntegration()],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    environment: import.meta.env.VITE_ENV,
    release: import.meta.env.VITE_SENTRY_RELEASE,
    tracesSampleRate: 0.1,
    tracePropagationTargets: [/^\//],
  });

const container = document.getElementById('root') as HTMLElement;
const config = {
  // Callback called when an error is thrown and not caught by an ErrorBoundary.
  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
    console.warn('Uncaught error', error, errorInfo.componentStack);
  }),
  // Callback called when React catches an error in an ErrorBoundary.
  onCaughtError: Sentry.reactErrorHandler(),
  // Callback called when React automatically recovers from errors.
  onRecoverableError: Sentry.reactErrorHandler(),
};

enableMocking().then(() => {
  const root = ReactDOM.createRoot(container, config);
  root.render(
    <Provider store={store}>
      <App />
      <ToastContainer />
    </Provider>,
  );
});
